var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtmlCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180.363 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebebeb;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15{stroke-width:0px;}.cls-2{fill:#565656;}.cls-16{clip-path:url(#clippath);}.cls-3{fill:none;}.cls-17{opacity:.05;}.cls-18{mask:url(#mask);}.cls-4{fill:url(#linear-gradient);}.cls-19{clip-path:url(#clippath-1);}.cls-20{clip-path:url(#clippath-4);}.cls-21{clip-path:url(#clippath-3);}.cls-22{clip-path:url(#clippath-2);}.cls-23{clip-path:url(#clippath-7);}.cls-24{clip-path:url(#clippath-8);}.cls-25{clip-path:url(#clippath-6);}.cls-26{clip-path:url(#clippath-5);}.cls-27{clip-path:url(#clippath-9);}.cls-28{clip-path:url(#clippath-10);}.cls-5{fill:#1f62ae;}.cls-6{fill:#f16529;}.cls-7{fill:#e44d26;}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-5);}.cls-12{fill:url(#linear-gradient-6);}.cls-13{fill:#fff;}.cls-29{mask:url(#mask-1);}.cls-14{fill:#231f20;}.cls-15{fill:#3c9bd5;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.21,
    y: 7.967,
    width: 36.094,
    height: 36.094
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.21,
    y: 7.967,
    width: 36.094,
    height: 36.094
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.21,
    y: 7.967,
    width: 36.094,
    height: 36.094
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "29.257 26.688 29.455 29.16 35.25 26.682 35.25 24.192 29.257 26.688"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -9266.846,
    y1: -4896.695,
    x2: -9266.592,
    y2: -4896.695,
    gradientTransform: "translate(-95482.192 -180729.021) rotate(-90) scale(19.506 -19.506)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 29.257,
    y: 24.192,
    width: 5.994,
    height: 4.968,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 29.257,
    y: 24.192,
    width: 5.994,
    height: 4.968
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -9266.846,
    y1: -4896.695,
    x2: -9266.592,
    y2: -4896.695,
    gradientTransform: "translate(-95482.192 -180729.021) rotate(-90) scale(19.506 -19.506)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0d2d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#d0d2d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0d2d3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "35.25 24.192 35.25 26.682 41.415 24.046 41.67 21.518 35.25 24.192"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -9257.318,
    y1: -4879.811,
    x2: -9257.063,
    y2: -4879.811,
    gradientTransform: "translate(-98901.653 -187669.145) rotate(-90) scale(20.275 -20.275)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 35.25,
    y: 21.518,
    width: 6.42,
    height: 5.164,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 35.25,
    y: 21.518,
    width: 6.42,
    height: 5.164
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -9257.318,
    y1: -4879.81,
    x2: -9257.063,
    y2: -4879.81,
    gradientTransform: "translate(-98901.646 -187669.138) rotate(-90) scale(20.275 -20.275)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "29.265 26.688 29.464 29.16 38.356 29.187 38.157 32.483 35.231 33.306 32.419 32.597 32.248 30.552 29.635 30.552 29.976 34.5 35.26 36.062 40.515 34.528 41.197 26.688 29.265 26.688"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -8830.992,
    y1: -4583.854,
    x2: -8830.737,
    y2: -4583.854,
    gradientTransform: "translate(413766.522 -214724.95) scale(46.851 -46.851)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7e6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.21,
    y: 7.967,
    width: 36.094,
    height: 36.094
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 29.257,
    y: 26.688,
    width: 5.994,
    height: 9.374
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "28.717 21.518 29.029 24.046 41.415 24.046 41.67 21.518 28.717 21.518"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -8844.811,
    y1: -4575.809,
    x2: -8844.556,
    y2: -4575.809,
    gradientTransform: "translate(449913.831 -232722.537) scale(50.864 -50.864)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.21,
    y: 7.967,
    width: 36.094,
    height: 36.094
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 28.717,
    y: 21.518,
    width: 6.534,
    height: 2.528
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 180.363,
    height: 50
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "33.686 11.659 23.167 11.659 23.167 11.659 12.647 11.659 14.62 33.044 23.167 35.466 23.167 35.466 23.167 35.466 23.167 35.466 23.167 35.466 31.714 33.044 33.686 11.659"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "23.167 13.401 23.167 33.655 23.167 33.655 30.089 31.693 31.776 13.401 23.167 13.401"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "29.785 16.023 16.549 16.023 17.288 24.034 17.303 23.982 26.349 23.982 26.051 27.369 23.169 28.202 20.239 27.357 20.062 25.307 17.405 25.307 17.783 29.404 23.167 30.93 28.551 29.404 29.292 21.364 19.697 21.364 19.449 18.683 29.539 18.683 29.785 16.023"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.167,16.023h-6.618l.739,8.01.016-.052h5.863v-2.618h-3.47l-.247-2.68h3.717v-2.66ZM20.062,25.307h-2.657l.378,4.097,5.384,1.526v-2.729l-2.928-.844-.177-2.05Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "43.631 38.196 35.258 40.451 26.883 38.196 24.951 17.261 45.564 17.261 43.631 38.196"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "35.258 18.957 35.258 38.653 35.276 38.658 42.053 36.834 43.617 18.957 35.258 18.957"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "35.25 24.192 29.257 26.688 29.455 29.159 35.25 26.682 41.415 24.046 41.67 21.518 35.25 24.192"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 29.257,
    y: 24.192,
    width: 5.994,
    height: 4.968
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 35.25,
    y: 21.518,
    width: 6.42,
    height: 5.164
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 29.265,
    y: 26.688,
    width: 11.931,
    height: 9.374
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "35.25 26.688 29.257 26.688 29.455 29.159 35.25 29.178 35.25 26.688"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "35.25 33.299 35.222 33.307 32.409 32.597 32.239 30.552 29.626 30.552 29.967 34.5 35.25 36.062 35.25 33.299"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 28.717,
    y: 21.518,
    width: 12.953,
    height: 2.528
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "35.25 21.518 28.717 21.518 29.029 24.046 35.25 24.046 35.25 21.518"
  })))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.443,18.76v12.564h-2.521v-5.346h-5.382v5.346h-2.52v-12.564h2.52v5.166h5.382v-5.166h2.521Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.477,18.76v2.034h-3.348v10.53h-2.521v-10.53h-3.348v-2.034h9.216Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.011,18.76v12.564h-2.521v-8.172l-3.366,8.172h-1.907l-3.385-8.172v8.172h-2.52v-12.564h2.861l3.996,9.343,3.996-9.343h2.845Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.014,29.327h4.141v1.998h-6.66v-12.564h2.52v10.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.707,31.325l-1.368-1.35c-1.164,1.044-2.586,1.565-4.266,1.565-.925,0-1.737-.159-2.439-.477-.702-.318-1.245-.769-1.629-1.351s-.576-1.257-.576-2.024c0-.828.234-1.572.702-2.232.468-.659,1.158-1.193,2.07-1.602-.324-.396-.559-.777-.702-1.144-.145-.365-.216-.759-.216-1.179,0-.576.149-1.095.449-1.557s.729-.825,1.287-1.09c.559-.264,1.209-.396,1.953-.396.756,0,1.404.144,1.944.432s.941.673,1.206,1.152c.264.48.378,1.015.342,1.602h-2.448c.012-.396-.084-.698-.288-.908s-.479-.315-.828-.315c-.336,0-.614.099-.837.297-.222.198-.333.453-.333.766,0,.3.091.597.271.891s.474.657.882,1.089l3.168,3.132c.024-.023.042-.048.054-.071.012-.024.024-.048.036-.072l1.026-1.71h2.628l-1.26,2.214c-.24.468-.498.912-.774,1.332l3.042,3.006h-3.096ZM115.754,28.409l-3.096-3.06c-1.164.516-1.746,1.248-1.746,2.195,0,.54.204.993.611,1.359.408.366.948.549,1.62.549.984,0,1.854-.348,2.61-1.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.553,21.704c.559-.978,1.32-1.739,2.286-2.286.966-.546,2.049-.818,3.249-.818,1.404,0,2.634.359,3.69,1.079,1.056.721,1.793,1.717,2.214,2.988h-2.898c-.288-.6-.692-1.05-1.215-1.35-.521-.3-1.125-.45-1.809-.45-.732,0-1.384.171-1.953.513-.57.343-1.015.825-1.332,1.449-.318.624-.478,1.356-.478,2.196,0,.828.159,1.557.478,2.187.317.63.762,1.116,1.332,1.458.569.342,1.221.514,1.953.514.684,0,1.287-.153,1.809-.459.522-.307.927-.759,1.215-1.359h2.898c-.421,1.284-1.155,2.283-2.205,2.997-1.051.714-2.283,1.071-3.699,1.071-1.2,0-2.283-.273-3.249-.819s-1.728-1.305-2.286-2.277c-.558-.972-.837-2.075-.837-3.312s.279-2.343.837-3.321Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.123,31.001c-.702-.3-1.257-.731-1.665-1.296-.408-.563-.618-1.229-.63-1.998h2.7c.036.517.219.925.549,1.225s.783.449,1.359.449c.588,0,1.05-.141,1.386-.423.336-.281.504-.65.504-1.106,0-.372-.114-.678-.342-.918-.229-.24-.514-.43-.855-.567s-.812-.291-1.413-.459c-.815-.24-1.479-.477-1.988-.711-.511-.234-.948-.588-1.314-1.062-.366-.474-.549-1.106-.549-1.898,0-.744.186-1.392.558-1.944.372-.552.895-.975,1.566-1.269s1.439-.441,2.304-.441c1.296,0,2.35.315,3.159.945s1.257,1.509,1.341,2.637h-2.771c-.024-.432-.207-.789-.55-1.071-.342-.281-.795-.423-1.358-.423-.492,0-.885.126-1.179.378-.295.252-.441.618-.441,1.099,0,.336.11.615.333.837.222.222.498.402.828.54s.795.297,1.395.477c.816.24,1.482.48,1.998.72.516.24.96.601,1.332,1.08.372.48.559,1.11.559,1.891,0,.672-.175,1.296-.522,1.872-.348.575-.858,1.035-1.53,1.377s-1.47.513-2.394.513c-.876,0-1.665-.149-2.367-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.085,31.001c-.702-.3-1.257-.731-1.665-1.296-.408-.563-.618-1.229-.63-1.998h2.7c.036.517.219.925.549,1.225s.783.449,1.359.449c.588,0,1.05-.141,1.386-.423.336-.281.504-.65.504-1.106,0-.372-.114-.678-.342-.918-.229-.24-.514-.43-.855-.567s-.812-.291-1.413-.459c-.815-.24-1.479-.477-1.988-.711-.511-.234-.948-.588-1.314-1.062-.366-.474-.549-1.106-.549-1.898,0-.744.186-1.392.558-1.944.372-.552.895-.975,1.566-1.269s1.439-.441,2.304-.441c1.296,0,2.35.315,3.159.945s1.257,1.509,1.341,2.637h-2.771c-.024-.432-.207-.789-.55-1.071-.342-.281-.795-.423-1.358-.423-.492,0-.885.126-1.179.378-.295.252-.441.618-.441,1.099,0,.336.11.615.333.837.222.222.498.402.828.54s.795.297,1.395.477c.816.24,1.482.48,1.998.72.516.24.96.601,1.332,1.08.372.48.559,1.11.559,1.891,0,.672-.175,1.296-.522,1.872-.348.575-.858,1.035-1.53,1.377s-1.47.513-2.394.513c-.876,0-1.665-.149-2.367-.45Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlCss);
export default __webpack_public_path__ + "static/media/Html&Css.f3c694e9c34e24dffc70cf90494812a0.svg";
export { ForwardRef as ReactComponent };